import { QueryClientProvider } from "@tanstack/react-query"
import type * as React from "react"
import { I18nextProvider } from "react-i18next"
import { queryClient } from "@/api/query-client"
import { ClickRipple } from "@/components/app/click-ripple"
import { ConfirmProvider } from "@/components/app/confirm-dialog"
import { Toaster } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import i18n from "@/i18n"
import { ThemeProvider } from "@/providers/theme"

/** Every app-wide provider, in dependency order. */
export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delay={400}>
            <ConfirmProvider>
              {children}
              <ClickRipple />
              {/* top-center: bottom-right toasts covered the Save button in side-sheet footers */}
              <Toaster position="top-center" closeButton richColors={false} />
            </ConfirmProvider>
          </TooltipProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </I18nextProvider>
  )
}
